import React from "react";
import { createRoot } from "react-dom/client";
import Root from "./components/JudgesList/Root";
import * as Sentry from "@sentry/react";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import { ThemeProvider, createTheme } from "@mui/material/styles";
const container = document.getElementById("root");
const root = createRoot(container);
Sentry.init({
    dsn: "https://ae1effe58a54456f90d5c59f43ef10a5@o294580.ingest.sentry.io/4504563618545664",
    // integrations: [new Sentry.Integrations.Breadcrumbs({ console: false })],
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],

    tunnel: "https://baza.polskitaniec.org/tunnel",

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.5,
  
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.5,
});
const darkTheme = createTheme({
    palette: {
        mode: window.APP_PROPS.itemOptions.color,
    },
});
// console.log(window.APP_PROPS);
root.render(
    <React.Fragment>
        <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <Container maxWidth="md">
                {/* <Sentry.ErrorBoundary fallback={<div className="alert alert-danger">Wystąpił błąd - prosimy o kontakt z administratorem.</div>}> */}
                    <Root {...window.APP_PROPS} type="chairperson" />
                {/* </Sentry.ErrorBoundary> */}
            </Container>
        </ThemeProvider>
    </React.Fragment>
);
